import React from "react";
import isString from "lodash/isString";
import loadjs from "loadjs";

import { getLabel } from "./util";
import * as caUtil from "@callApi";
import { checkSSO } from "../wea-tools/checkSSO";
import wm from "../wea-tools/watermark";
import WindowFunc from "../wea-tools/window";

const callApi = caUtil.callApi;

const localeKey = "e9_locale";

const constant = {
  langRegP: /(~`~`(([\d ]{1,2}[^`]{0,2000}?`~`)+[\d ]{1,2}[^`]{0,2000}?)`~`~).{0,2000}?/i,
  blank: /&nbsp;/g,
  LANG_CONTENT_PREFIX: "~`~`",
  LANG_CONTENT_SPLITTER1: "`~`",
  LANG_CONTENT_SUFFIX: "`~`~",
  LANG_INPUT_PREFIX: "__multilangpre_"
};

const getLocale = () => window[localeKey];

const getUserLanguage = () => {
  if (localStorage.login) {
    try {
      const login = JSON.parse(localStorage.login);
      if (login.langId) {
        return login.langId;
      }
      if (window[localeKey]) {
        return window[localeKey].userLanguage || 7;
      }
    } catch (error) {
      console && console.error("多语言获取失败 :(", error);
    }
  }
};

const getOs = () => {
  callApi("/api/system/info/getOSinfo", "GET", {})
    .then(res => {
      if (res.status) {
        const { defaultLinkMode, dragColumns, uploadSuffixLimit } = res;
        window.localStorage.setItem("ec_open_rewrite", defaultLinkMode);
        window.localStorage.setItem("dragColumns_WeaTable", dragColumns);
        window.localStorage.setItem("uploadSuffixLimit", uploadSuffixLimit);
      }
    })
    .catch(err => {
      // window.console && window.console.log('err: ', err);
    });
  // window.localStorage.removeItem("ec_open_rewrite");
};

// const overTime =(msg, timeout) => new Promise((rs, rj) => {
//   setTimeout(() => rs(msg), timeout);
// });

const isInMain = () =>
  window.location.href.indexOf("/wui/index") > 0 ||
  window.location.href.indexOf("/wui/engine") > 0;

const checkModuleCode = (moduleCode, isFetch) => {
  if (!moduleCode || !`${moduleCode}`) return false;
  let mod = [];
  if (Array.isArray(moduleCode)) {
    mod = isFetch ? [...moduleCode] : moduleCode.filter(m => m === "common");
  } else if (typeof moduleCode === "string" && moduleCode.indexOf(",") > 0) {
    mod = moduleCode.split(",");
  } else {
    mod = [moduleCode];
  }
  if (window[localeKey] && !isFetch) {
    mod = mod.filter(
      m => !window[localeKey].loadedModules.some(_m => _m === m)
    );
  }
  if (mod.length === 0) return false;
  if (window[localeKey] && !isFetch) {
    window[localeKey].loadedModules = window[localeKey].loadedModules.concat(
      mod
    );
  }
  return mod;
};

const getLocaleLabelByLang = (moduleCode, languageId = "") =>
  new Promise((rs, rj) => {
    let mod = [];
    if (Array.isArray(moduleCode)) {
      mod = [...moduleCode];
    } else if (typeof moduleCode === "string" && moduleCode.indexOf(",") > 0) {
      mod = moduleCode.split(",");
    } else {
      mod = [moduleCode];
    }
    callApi("/api/ec/dev/locale/getLabelByModule", "GET", {
      moduleCode: `${mod}`,
      languageId: languageId
    }).then(result => {
      const { datas, language } = result;
      if (!window[localeKey] || window[localeKey].userLanguage != languageId) {
        window[localeKey] = {
          userLanguage: language,
          loadedModules: [],
          reloadedModules: []
        };
      } else {
        window[localeKey].userLanguage = language;
      }
      if (Array.isArray(datas)) {
        datas.forEach(item => {
          if (!window[localeKey][item.type]) {
            window[localeKey][item.type] = {};
          }
          window[localeKey][item.type][item.id] = item.label;
        });
        window.localStorage[localeKey] = JSON.stringify(window[localeKey]);
      }
      window[localeKey].loadedModules = window[localeKey].loadedModules.concat(
        mod
      );
      rs();
    });
  });

const getLocaleLabelByCode = (moduleCode, isform = false) =>
  new Promise((rs, rj) => {
    if (isform) {
      if (window[localeKey]) {
        rs();
        return;
      } else {
        if (window.localStorage[localeKey]) {
          window[localeKey] = JSON.parse(window.localStorage[localeKey]);
        }
      }
    }
    const mod = checkModuleCode(moduleCode, true);
    !mod
      ? rs()
      : callApi("/api/ec/dev/locale/getLabelByModule", "GET", {
          moduleCode: `${mod}`
        }).then(result => {
          const { datas, language, browserConfig } = result;
          if (!window[localeKey]) {
            window[localeKey] = {
              userLanguage: language,
              loadedModules: [],
              reloadedModules: []
            };
          } else {
            window[localeKey].userLanguage = language;
          }
          if (browserConfig) {
            const {
              timeInterval,
              typeList,
              defaultPageSize,
              pageConfigList
            } = browserConfig;
            // 获取浏览按钮显示设置
            window.ecBrowserDisplayStyle = typeList || [];
            // 获取系统时间间隔设置
            window.ecTimePickerMinuteStep = timeInterval || 1;
            // 获取浏览按钮默认显示条数
            window.ecBrowserDisplayPageSize = defaultPageSize || 10;
            // 获取浏览按钮显示条数配置
            window.ecBrowserDisplayConfigList = pageConfigList || [];
          }
          if (Array.isArray(datas)) {
            datas.forEach(item => {
              if (!window[localeKey][item.type]) {
                window[localeKey][item.type] = {};
              }
              window[localeKey][item.type][item.id] = item.label;
            });
          }
          window[localeKey].loadedModules = window[
            localeKey
          ].loadedModules.concat(mod);
          window.localStorage[localeKey] = JSON.stringify(window[localeKey]);
          rs();
        });
  });

// 用于写在 React-Router 的 onEnter 中
const getLocaleLabel = (moduleCode, nextState, replace, callback) => {
  const callbackFunction = typeof callback === "function";
  if (!callbackFunction) {
    console && console.log("on enter router callback not function");
  }
  // check sso
  if (!window.ssoChecked) {
    checkSSO().then(() => {
      if (
        !/.*appid=.*&service=.*/.test(window.location.href) &&
        !window.loadCas
      ) {
        // window.loadCas = true;
        callApi("/api/integration/common1/checkCasIsDeployed", "POST", {}).then(
          res => {
            if (
              !res.hasSession &&
              res.isDeployed &&
              res.weaver_login_type !== "OALogin"
            ) {
              let servicePath = window.location.pathname + window.location.hash;
              if (/\/wui\/index\.html\#\/\?/.test(servicePath)) {
                servicePath = "/wui/index.html#/main";
              }
              let service =
                window.location.protocol +
                "//" +
                window.location.host +
                "/wui/cas-entrance.jsp?path=" +
                encodeURIComponent(servicePath) +
                `&ssoType=${res.ssoType}`;
              // if (
              //   res.useAuthenticationCenter === false &&
              //   res.casServerLoginUrl
              // ) {
              //   let paramsMark = "?";
              //   if (res.casServerLoginUrl.indexOf("?") !== -1) {
              //     paramsMark = "&";
              //   }
              //   window.location.href = `${
              //     res.casServerLoginUrl
              //   }${paramsMark}${res.refererParameterName ||
              //     "service"}=${encodeURIComponent(service)}&ssoType=${
              //     res.ssoType
              //   }`;
              // } else {
              //   window.location.href = `/wui/index.html#/?appid=${
              //     res.appid
              //   }&service=${encodeURIComponent(service)}`;
              // }
              window.location.href = service;
            } else {
              sessionInitFuncs(moduleCode, nextState, replace, callback);
            }
          }
        );
      } else {
        sessionInitFuncs(moduleCode, nextState, replace, callback);
      }
    });
  } else {
    getLocaleLabelInner(moduleCode, nextState, replace, callback);
  }
};

const sessionInitFuncs = (moduleCode, nextState, replace, callback) => {
  if (
    window.loadEcSessionApi !== false &&
    !/.*\/login\/OALogin\.jsp.*/.test(WindowFunc.getTop().location.href) &&
    !/.*\/wui\/index(-admin)?\.html.*#\/\?.*/.test(
      WindowFunc.getTop().location.href
    ) &&
    !/.*\/wui\/index(-admin)?\.html$/.test(WindowFunc.getTop().location.href)
  ) {
    getOs();
    try {
      // 加载组件库时，设置系统水印
      wm.getSystemSetting();
    } catch (error) {}
  }
  getLocaleLabelInner(moduleCode, nextState, replace, callback);
};

const getLocaleLabelInner = (moduleCode, nextState, replace, callback) => {
  const callbackFunction = typeof callback === "function";
  if (!callbackFunction) {
    console && console.log("on enter router callback not function");
  }
  const mod = checkModuleCode(moduleCode);
  // if (!mod && callbackFunction) {
  //   callback();
  //   return;
  // }
  const userLanguage = Number(getUserLanguage());
  if (!window[localeKey]) {
    window[localeKey] = {
      userLanguage,
      loadedModules: [],
      reloadedModules: []
    };
    window.localStorage[localeKey] = JSON.stringify(window[localeKey]);
    getLocaleLabelByCode(["common"].concat(mod)).then(
      () => callbackFunction && callback()
    );
  } else {
    if (userLanguage !== window[localeKey].userLanguage) {
      window[localeKey].loadedModules = [];
      window.localStorage[localeKey] = JSON.stringify(window[localeKey]);
      getLocaleLabelByCode(["common"].concat(mod)).then(
        () => callbackFunction && callback()
      );
    } else {
      getLocaleLabelByCode(mod).then(() => callbackFunction && callback());
    }
  }
  // 加载字体大小
  if (!isInMain()) {
    if (
      localStorage["theme-themeInfo"] &&
      JSON.parse(localStorage["theme-themeInfo"])
    ) {
      let fontSize = JSON.parse(localStorage["theme-themeInfo"]).themeFontSize;
      if (fontSize) fontSize = Number(fontSize);
      if (!loadjs.isDefined(`fontSize_${fontSize}`)) {
        loadjs(
          `/cloudstore/resource/pc/com/font-size/${fontSize}px.css`,
          `fontSize_${fontSize}`
        );
      }
    }
  }
};

const transLang = (str, lang) => {
  //如果没有设过相应语言的翻译，返回中翻译作为默认值
  let isExsit = false,
    defaultValue = "",
    oriLang = lang;
  if (lang.length < 2) lang += " ";
  str = str.replace(constant.blank, " ");
  let from = str.indexOf(constant.LANG_CONTENT_PREFIX),
    to = str.lastIndexOf(constant.LANG_CONTENT_SUFFIX);
  if (from != -1 && to != -1 && from + 4 < to) {
    let ls = str.substring(from + 4, to).split(constant.LANG_CONTENT_SPLITTER1);
    for (let i = 0; i < ls.length; i++) {
      let lg = ls[i];
      if (lg.indexOf("7 ") === 0) {
        defaultValue = lg.substring(lang.length);
      }
      if (lg.indexOf(lang) === 0) {
        isExsit = true;
        return lg.substring(lang.length);
      } else if (lg.startsWith(oriLang)) {
        isExsit = true;
        return lg.substring(oriLang.length);
      }
    }
  }
  if (!isExsit) {
    return defaultValue;
  }
  return str;
};

// 解析多语言对应的显示
const formatMultiLang = str => {
  if (!str || !isString(str) || str.indexOf(constant.LANG_CONTENT_PREFIX) < 0) {
    return str;
  }
  let lang = new String(getUserLanguage());
  let arr = null;
  while ((arr = str.match(constant.langRegP))) {
    let formatValue = arr[1];
    let value = transLang(formatValue, lang);
    str = str.replace(formatValue, value);
  }
  return str;
};

class WeaLocaleProvider extends React.Component {
  static getLabel = getLabel;
  static getLocale = getLocale;
  static getUserLanguage = getUserLanguage;
  static getLocaleLabel = getLocaleLabel;
  static getLocaleLabelByCode = getLocaleLabelByCode;
  static formatMultiLang = formatMultiLang;
  static transLang = transLang;
  static getLocaleLabelByLang = getLocaleLabelByLang;
  render = () => this.props.children;
}

export default WeaLocaleProvider;



// WEBPACK FOOTER //
// ./ecology9/wea-locale-provider/index.js